import { createBreakpoints } from '@chakra-ui/theme-tools';
import { breakpoint } from '@core-ds/primitives';

export default createBreakpoints({
   sm: `${breakpoint.sm}`,
   md: `${breakpoint.md}`,
   lg: `${breakpoint.lg}`,
   xl: `${breakpoint.xl}`,
});
